import React from 'react';
import ReactDOM from 'react-dom/client';
import '@shopify/polaris/build/esm/styles.css';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { LocaleProvider, useAdminLocale } from './i18n/LocaleProvider';
import { AppBridgeProvider } from './providers/AppBridgeProvider';
import { ApiProvider } from './providers/ApiProvider';
import { SessionTokenWarmup } from './providers/SessionTokenWarmup';
import { StoreProvider } from './providers/StoreProvider';

function Root() {
  const { locale } = useAdminLocale();
  return (
    <BrowserRouter>
      <AppBridgeProvider>
        <ApiProvider>
          <SessionTokenWarmup />
          <StoreProvider>
            <App key={locale} />
          </StoreProvider>
        </ApiProvider>
      </AppBridgeProvider>
    </BrowserRouter>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LocaleProvider>
      <Root />
    </LocaleProvider>
  </React.StrictMode>,
);
